import React from "react";
import Inview from "./inview";

export default class PrePaidCustomBlock extends React.Component {
    render() {
        // to make a banner: remove className `container row` and add class banner
        return (
            <div className="custom-block prepaid-homepage margin-t-l bg-white">
                <div className="container margin-xl">
                    <div className="row">
                        <div
                            className="col-lg-6 col-md-6 col-sm-6 col-xs-12 prepaid-header-text"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center"
                            }}
                        >
                            <h1 className="font-xxlarge">
                                Now you can
                                <br /> pre–pay for icons
                            </h1>
                            <p className="font-medium weight-light padding-r-xl">
                                You may not need icons every day. Now you can
                                add money to your account for a pre–paid balance
                                you can use any time you wish.
                            </p>
                            <a
                                className="button small blue"
                                href="/preview/prepay/"
                                target="_blank"
                            >
                                Try it out
                            </a>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <img
                                src={require("../../img/homepage/prepaid/prepaid_03.gif")}
                                alt="Add money to the pre–paid balance, use it whenever."
                                style={{
                                    margin: "auto",
                                    display: "block"
                                }}
                                width="100%"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
